function arrayContains(input, val){
    for(var i = 0; i < input.length; i++) {
        if(input[i] === val) return true;
    }
    return false;
}

function arrayUnique(input){
    
    var arr = [];
    
    if(!input){
        return arr;
    }
    
    for(var i = 0; i < input.length; i++) {
        if(!arrayContains(arr, input[i])) {
            arr.push(input[i]);
        }
    }
    return arr; 
}

function closest (num, arr) {
                var curr = arr[0];
                var diff = Math.abs (num - curr);
                for (var val = 0; val < arr.length; val++) {
                    var newdiff = Math.abs (num - arr[val]);
                    if (newdiff < diff) {
                        diff = newdiff;
                        curr = arr[val];
                    }
                }
                return curr;
            }

//Get unique list of particular property
function getUniqueProperties(from, prop, sort) {
    var ret = $.map(from, function (val, index) {
        return val[prop];
    }).filter(function (value, index, self) { //Get only uniqs
        return self.indexOf(value) === index;
    }).sort(function (a, b) { // Sort numbers
        return a - b;
    });

    if (sort) {
        ret.sort(function (a, b) { // Sort numbers
            return a - b;
        });
    }

    return ret;
}

function getListWhere(list, field, val) {

    //console.log('where running', field, val);

    var ret = $.map(list, function (el, i) {
        //console.log("Where comparing: ", el, el[field], val);
        var flag = false;

        if (typeof field === 'object') {
            for (var f in field) {

                //console.log("To Compare: ", f, el[f], field[f]);

                if (el[f] == field[f]) {
                    flag = true;
                }
            }

            return flag ? el : undefined;

        } else {
            if (el[field] == val) {
                return el;
            }
        }

    });

    //console.log("Where returned: ", ret);

    return ret;
}